import React from "react";
import Layout from "../../components/Layout/Layout";
import Feedback from "../../components/general/Feedback/Feedback";
import Questionnare from "../../components/pages/SampleQuestionnaire/Questionnare/Questionnare";

const SampleQuestionnairePage: React.FC = () => {
  return (
    <Layout>
      <Questionnare />
      <Feedback />
    </Layout>
  );
};

export default SampleQuestionnairePage;
